/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Iframe_Remote_Qc_Completed_MessageInputs */

const en_iframe_remote_qc_completed_message = /** @type {(inputs: Iframe_Remote_Qc_Completed_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`QC completed: ${i?.count} error(s) found`)
};

const fr_iframe_remote_qc_completed_message = /** @type {(inputs: Iframe_Remote_Qc_Completed_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`QC terminee : ${i?.count} erreur(s) trouvee(s)`)
};

const de_iframe_remote_qc_completed_message = /** @type {(inputs: Iframe_Remote_Qc_Completed_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Qualitätskontrolle abgeschlossen: ${i?.count} Fehler gefunden`)
};

const it_iframe_remote_qc_completed_message = /** @type {(inputs: Iframe_Remote_Qc_Completed_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Controllo qualità completato: ${i?.count} errore(i) trovato(i)`)
};

const ru_iframe_remote_qc_completed_message = /** @type {(inputs: Iframe_Remote_Qc_Completed_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Контроль качества завершен: ${i?.count} обнаружены ошибки.`)
};

const es_iframe_remote_qc_completed_message = /** @type {(inputs: Iframe_Remote_Qc_Completed_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Control de calidad completado: se encontraron ${i?.count} errores`)
};

const zh_cn2_iframe_remote_qc_completed_message = /** @type {(inputs: Iframe_Remote_Qc_Completed_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`质控完成：发现${i?.count}个错误`)
};

const ja_iframe_remote_qc_completed_message = /** @type {(inputs: Iframe_Remote_Qc_Completed_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`QC 完了: ${i?.count} 件のエラーが見つかりました`)
};

const hi_iframe_remote_qc_completed_message = /** @type {(inputs: Iframe_Remote_Qc_Completed_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`QC पूर्ण हुआ: ${i?.count} त्रुटि पाई गई`)
};

const pt_pt2_iframe_remote_qc_completed_message = /** @type {(inputs: Iframe_Remote_Qc_Completed_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Controle de qualidade concluído: ${i?.count} erro(s) encontrado(s)`)
};

/**
* | output |
* | --- |
* | "QC completed: {count} error(s) found" |
*
* @param {Iframe_Remote_Qc_Completed_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_qc_completed_message = /** @type {((inputs: Iframe_Remote_Qc_Completed_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Qc_Completed_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_qc_completed_message(inputs)
	if (locale === "de") return de_iframe_remote_qc_completed_message(inputs)
	if (locale === "it") return it_iframe_remote_qc_completed_message(inputs)
	if (locale === "ru") return ru_iframe_remote_qc_completed_message(inputs)
	if (locale === "es") return es_iframe_remote_qc_completed_message(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_qc_completed_message(inputs)
	if (locale === "ja") return ja_iframe_remote_qc_completed_message(inputs)
	if (locale === "hi") return hi_iframe_remote_qc_completed_message(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_qc_completed_message(inputs)
	return en_iframe_remote_qc_completed_message(inputs)
});